import Model  from '@/util/models';

export default class Provinsi extends Model { 
    backend = '/frc/provinsi/'; 
    
    saksiProvinsiBlank(params){
        return this.api.get('/frc/data/saksi-provinsi-blank', params);
    } 
}

